module.exports = __webpack_public_path__ + "static/pos-ab477c2f0d448d6b5402391ce233c32b.jpg";